module.exports = __webpack_public_path__ + "img/wf-finishing-position-3.9cef30ce.svg";